// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: pictures and files for an agent prompt go to Konvo first; the prompt then names them by
// upload id and the machine fetches them.

import {Endpoints} from '@app/features/app/constants/Endpoints';
import {http} from '@app/features/platform/transport/RestTransport';
import type {AgentUploaded, AgentUploadInput} from '@fluxer/schema/src/domains/konvo/Agents';

/** Each file goes to Konvo first; the prompt then names them and the machine fetches them. */
export function uploadAgentFiles(files: ReadonlyArray<File>): Promise<Array<AgentUploadInput>> {
	return Promise.all(
		files.map(async (file) => {
			const response = await http.post<AgentUploaded>(Endpoints.KONVO_AGENTS_UPLOADS, {
				body: file,
				query: {name: file.name || 'pasted-image.png'},
				headers: {'content-type': file.type || 'application/octet-stream'},
			});
			return {uploadId: response.body.uploadId};
		}),
	);
}
